import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MakeAlign from './MakeAlign';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MakeAlign />
  </React.StrictMode>
);
